let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bX8u3")).then(() => parcelRequire('5pWl8'));